import React, { Suspense, lazy } from 'react'
import { CSSReset } from '@chakra-ui/css-reset'
import { Global } from '@emotion/react'
import { Themed } from '@theme-ui/mdx'
import Headroom from 'react-headroom'
import { Helmet } from 'react-helmet'
import NavBar from './nav'
import SEO from './seo'

import 'typeface-barlow-condensed'

const Footer = lazy(() => import('./footer'))

const Layout = ({ children }) => {
  return (
    <>
      <SEO />
      <CSSReset />
      <Global
        styles={theme => ({
          '.covid19': {
            color: '#D52925',
            backgroundColor: '#fff',
            padding: '20px 10px',
            textAlign: 'center',
          },
          '.covid19 a': {
            backgroundColor: '#D52925',
            color: '#fff',
            padding: '10px 20px',
            borderRadius: '20px',
            display: 'block',
            width: '150px',
            margin: '20px auto 0 auto',
            border: '1px solid #D52925',
          },
          '.covid19 a:hover': {
            color: '#D52925',
            backgroundColor: '#fff',
            textDecoration: 'none',
          },
          '.tl-edges': { overflowX: 'visible' },
          body: {
            color: theme.colors.text,
            touchAction: 'manipulation',
            backgroundColor: theme.colors.background,
            padding: 0,
            m: 0,
            maxWidth: '100vw',
            overflowX: 'hidden',
          },
        })}
      />
      <Helmet>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0"
        />
        <html lang="en" />
        <script src="//scripts.iconnode.com/74727.js" async />
        <script src="https://www.clickcease.com/monitor/stat.js" async />
      </Helmet>
      {/* eslint-disable-next-line react/jsx-pascal-case */}
      <Themed.root>
        <Headroom style={{ zIndex: 100 }}>
          <NavBar id="nav" />
        </Headroom>
        {children}
        <Suspense fallback="loading">
          <Footer />
        </Suspense>
        <img
          src="https://rdcdn.com/rt?aid=20532&e=1&img=1"
          height="1"
          width="1"
          referrerPolicy="no-referrer-when-downgrade"
          alt=""
        />
      </Themed.root>
      <noscript>
        <a href="https://www.clickcease.com" rel="nofollow">
          <img src="https://monitor.clickcease.com" alt="ClickCease" />
        </a>
      </noscript>
    </>
  )
}

export default Layout
